import React from 'react';
import { SmHyperlink } from '@smiles/smiles-react-design-system';

type TProps = React.HTMLProps<HTMLAnchorElement> & {
  text: string;
};

export function Hyperlink({ className, href, text, onClick }: TProps) {
  return (
    <SmHyperlink
      className={className}
      href={href}
      text={text}
      onClick={onClick}
    />
  );
}
